let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("kUP81")).then(() => parcelRequire('633nq'));